import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

export const classes = {
	filter: 'm-event-list__filter',
	filterLabel: 'js-event-list__filter-label',
	filterOpen: 'm-event-list__filter--open',
	filterClose: 'js-event-list__filter--close',
	filterTags: 'm-event-list__filter-tags',
	filterTag: 'm-event-list__filter-tag',
	filterTagContainer: 'm-event-list__filter-tags-container',
	counterLabel: 'm-event-list__counter-label',
	counterHeading: 'js-event-list_counter-heading',
	filterSelect: 'm-event-list__select',
	clearFilterBtn: 'm-event-list__clear-filter',
	loadMoreBtn: 'js-load-more-button',
	teaserContainer: 'm-event-list__teaser-list',
	stateHidden: 'h-visuallyhidden',
	teaserBlock:'m-teaser-event',
	teaserColorBlock:'m-teaser-event__text-area',

	twoLevelmainItemLink: 'js-m-filter-two-level-multiselect__item-link--main',

	twoLevelSelector: 'm-filter-two-level-multiselect',
	twoLevelList: 'm-filter-two-level-multiselect__list-level1',
	twoLevelListOpen: 'm-filter-two-level-multiselect__list-level1--open',

	twoLevelMainChecked: 'm-filter-two-level-multiselect__item-link--main-checked',

	twoLevelParent: 'js-m-filter-two-level-multiselect__item--level2',
	twoLevelParentHeader: 'js-m-filter-two-level-multiselect__layer-header-level3',
	twoLevelParentLink: 'js-m-filter-two-level-multiselect__item-link',
	twoLevelParentChecked: 'm-filter-two-level-multiselect__item-link--parent-checked',
	twoLevelParentDisabled: 'm-filter-two-level-multiselect__item-link--parent-disabled',

	// ul
	twoLevelChildList: 'js-m-filter-two-level-multiselect__list-level3',
	// li
	twoLevelChild: 'js-m-filter-two-level-multiselect__item--level3',
	twoLevelChildDisabled: 'm-filter-two-level-multiselect__item--child-disabled',
	twoLevelChildInputDisabled: 'a-input-checkbox--disabled',

	twoLevelMainClose: 'm-filter-two-level-multiselect__item-link--main-mobile-close-icon',

	oneLevelSelector: 'm-filter-multiselect',
	oneLevelItemContainer: 'm-filter-multiselect__list-level2',
	oneLevelList: 'm-filter-multiselect__item--level1',
	oneLevelListOpen: 'm-filter-multiselect__item--level1-open',
	oneLevelMain: 'js-m-filter-multiselect__item-link--main',
	oneLevelMainChecked: 'm-filter-multiselect__item-link--main-checked',
	oneLevelDisabled: 'a-input-checkbox--disabled',
	oneLevel: 'js-m-filter-multiselect__item--level2',
	oneLevelClose: 's-filter-multiselect__item-link--main-close-icon'
}

const placeholders = {
	displayNumber: "{displaynumber}",
	totalNumber: "{totalnumber}"
}

const names = {
	dateSelector: 'EventList-Date',
	regionSelector: 'EventList-Region',
	materialSelector: 'EventList-Material',
	industrySelector: 'EventList-Industry'
}

const parameterSet = {
	material: 'material',
	industry: 'industry',
	date: 'date',
	region: 'region'
}

@createModule('EventList')
/**
 * event-list module implementation.
 *
 * @author Sandy Zhao <Sandy.Zhao@delaware.pro>
 */
export class EventList extends TerrificSpec {
	$ctx: JQuery;

	start(resolve: Function) {
		this.$ctx = $(this._ctx);

		this.$ctx.find(`.${classes.filterLabel}`).on('click', this.onOpenFilter.bind(this));

		this.$ctx.find(`.${classes.filterClose}, .${classes.twoLevelMainClose},.${classes.oneLevelClose}`)
			.on('click', this.onCloseFilter.bind(this));

		this.$ctx.on('FilterTwoLevelMultiCheckboxChanged',
			(event: any, clickEvent: Event) => {
				this.dataChanged(clickEvent);
			});

		this.$ctx.on('FilterMultiCheckboxChanged',
			(event: any, clickEvent: Event) => {
				this.dataChanged(clickEvent);
			});

		this.$ctx.find("input[type='checkbox']").on("click", () => false);

		$(document).on("click", `.${classes.filterTag}`, this.removeSelectedTag.bind(this));

		this.$ctx.find(`.${classes.clearFilterBtn}`).on("click", this.clearAllFilters.bind(this));

		this.$ctx.find(`.${classes.loadMoreBtn}`).on("click", this.loadMore.bind(this));

		this.initTeaserData();

		$(window).resize(function () {
			const $teaserTextAreas = $(`.${classes.teaserColorBlock}`);

			$teaserTextAreas.each((i, e) => {
				const $textArea = $(e);
				const height = $textArea.height();
				$textArea.closest(`.${classes.teaserBlock}`).css("min-height", height + 88);
			});
		});

		resolve();
	}

	initTeaserData() {

		//get url query string ids, for pre-check
		const dateParaValue = this.getIdParameterValueFromUrl(parameterSet.date);

		const regionIdParaValue = this.getIdParameterValueFromUrl(parameterSet.region);

		const materialIdParaValue = this.getIdParameterValueFromUrl(parameterSet.material);

		const industryIdParaValue = this.getIdParameterValueFromUrl(parameterSet.industry);

		this.getTeaserData(1, dateParaValue, regionIdParaValue, materialIdParaValue, industryIdParaValue);
	}

	dataChanged(event: Event) {

		event.stopPropagation();
		event.preventDefault();

		this.$ctx.find(`.${classes.teaserContainer}`).empty();

		const materialQuery = this.getIdParameterValue(names.materialSelector);
		const industryQuery = this.getIdParameterValue(names.industrySelector);
		const dateQuery = this.getIdParameterValue(names.dateSelector);
		const regionQuery = this.getIdParameterValue(names.regionSelector);

		this.getTeaserData(1, dateQuery, regionQuery, materialQuery, industryQuery);

	}

	getTeaserData(pageNumber: number,
		dateQuery?: string,
		regionQuery?: string,
		materialQuery?: string,
		industryQuery?: string) {

		this.lockFilters();
		this.lockLoadMoreButton();
		const searchRootId = this.$ctx.data("search-root");
		const initNum = this.$ctx.data("init-number");
		const apiEndpoint = this.$ctx.data("api-endpoint");
		const pageSize = this.$ctx.data("page-size");
		const configuration = this.$ctx.data("configuration");

		$.ajax({
			type: 'POST',
			url: apiEndpoint,
			dataType: 'html',
			data:
			{
				dateQuery: dateQuery,
				regionQuery: regionQuery,
				materialQuery: materialQuery,
				industryQuery: industryQuery,
				searchRootId: searchRootId,
				pageSize: pageSize,
				pageNumber: pageNumber,
				initNumber: initNum,
				Configuration: configuration
			},
			success: (response: any) => {
				console.log("success");
				// ⚠
				// Add the response HTML to the bottom of the container - for now.
				// Additional logic will need to be added to decide whether it needs to be
				// added (in case of 'load more') or completely replaced instead.
				// ⚠
				let container = this.$ctx.find(`.${classes.teaserContainer}`);
				container.append(response);
				// Look for a script tag containing extra data.
				let data = container.find("script[type='application/json']");
				if (data.length > 0) {
					let json = data[0].innerHTML;
					let jsonData = JSON.parse(json);

					if (jsonData.totalNumber > 0) {
						this.updateCounterLabel(jsonData.displayNumber, jsonData.totalNumber);
						this.updateCounterHeading(jsonData.totalNumber);
						this.updateLoadMoreButton(jsonData.enableLoadMore);
						this.updatePageNumber(jsonData.pageNumber + 1);
						this.updateFacet(jsonData.enabledFilterItems);
						this.updateTeaserHeight();

					} else {
						this.updateNoResult();
					}

					// Remove the script tag.
					data.remove();
				} else {
					this.updateNoResult();
				}
			},
			complete: () => {
				this.unlockFilters();
				this.generateSelectedTags();
				this.updateUrl();
			},
			error: () => {
				console.log("get teaser data error");
			}
		});
	}

	updateTeaserHeight() {
		const $teaserTextAreas = this.$ctx.find(`.${classes.teaserColorBlock}`);

		$teaserTextAreas.each((i, e) => {
			const $textArea = $(e);
			const height = $textArea.height();
			$textArea.closest(`.${classes.teaserBlock}`).css("min-height", height + 88);
		});
	}

	updateUrl() {
		let parameterList = new Array<string>();

		const dateParameter = this.getUniqueNameParameter(names.dateSelector, parameterSet.date);
		if (dateParameter.length > 0) {
			parameterList.push(dateParameter);
		}

		const regionParameter = this.getUniqueNameParameter(names.regionSelector, parameterSet.region);
		if (regionParameter.length > 0) {
			parameterList.push(regionParameter);
		}

		const materialParameter = this.getUniqueNameParameter(names.materialSelector, parameterSet.material);
		if (materialParameter.length > 0) {
			parameterList.push(materialParameter);
		}

		const industryParameter = this.getUniqueNameParameter(names.industrySelector, parameterSet.industry);
		if (industryParameter.length > 0) {
			parameterList.push(industryParameter);
		}

		const searchQuery = this.generateUniqueNameQueryString(parameterList);

		if (searchQuery.length > 0) {
			history.pushState(null, null, searchQuery);
		} else {
			history.pushState(null, null, "?");
		}

	}

	generateSelectedTags() {

		const $tagContainer = this.$ctx.find(`.${classes.filterTagContainer}`);
		$tagContainer.empty();

		//Two-Level Selector: if all child-item are ticked, show the parent-item tag
		const $twoLevelParents = this.$ctx.find(`.${classes.twoLevelSelector}`).find(`.${classes.twoLevelParent}`);

		$twoLevelParents.each((i, e) => {
			const selectorName = $(e).closest(`.${classes.filterSelect}`).attr("name");
			let $checkboxes = $(e).find(`.${classes.twoLevelChild}`).find("input[type='checkbox']");

			if ($checkboxes.length > 0 && this.areAllSubFiltersChecked($checkboxes)) {
				let $parentSelectedOption =
					$(e).find(`.${classes.twoLevelParentHeader}`).find("input[type='checkbox']");
				const tagHtml = this.getSelectedTagHtml($parentSelectedOption);
				$tagContainer.append(tagHtml);
			} else {
				let $checkedboxes = $(e).find(`.${classes.twoLevelChild}`).find("input[type='checkbox']:checked");
				if ($checkedboxes.length > 0) {
					$checkedboxes.each((childIndex, childEle) => {
						let tagHtml: string;
						//if the selector is date-selector, add the "year" 
						if (selectorName === names.dateSelector) {
							tagHtml = this.getSelectedDateMonthTagHtml($(childEle));
						} else {
							tagHtml = this.getSelectedTagHtml($(childEle));
						}
						$tagContainer.append(tagHtml);
					});
				}
			}

		});


		//One-Level Selector
		const $oneLevelSelectedOptions = this.$ctx.find(`.${classes.oneLevelSelector}`).find("input:checked");

		$oneLevelSelectedOptions.each((oneLevelIndex, oneLevelEle) => {
			const tagHtml = this.getSelectedTagHtml($(oneLevelEle));
			$tagContainer.append(tagHtml);
		});

		if ($tagContainer.html().length > 0) {
			this.$ctx.find(`.${classes.filterTags}`).show();
		} else {
			this.$ctx.find(`.${classes.filterTags}`).hide();
		}

	}

	removeSelectedTag(event: Event) {
		const $currentTargetElement = $(event.currentTarget);

		const id = $currentTargetElement.find("span").attr("data-selected-id");

		this.$ctx.find(`input[data-sc-id='${id}']`).parent().parent().triggerHandler("click");

		$currentTargetElement.remove();
	}

	clearAllFilters() {
		this.$ctx.find(`.${classes.filterSelect}`).find("input").prop('checked', false);

		this.$ctx.find(`.${classes.filterSelect}`).find(`.${classes.twoLevelMainChecked}`)
			.removeClass(`${classes.twoLevelMainChecked}`);
		this.$ctx.find(`.${classes.filterSelect}`).find(`.${classes.twoLevelParentChecked}`)
			.removeClass(`${classes.twoLevelParentChecked}`);
		this.$ctx.find(`.${classes.filterSelect}`).find(`.${classes.oneLevelMainChecked}`)
			.removeClass(`${classes.oneLevelMainChecked}`);

		this.$ctx.find(`.${classes.filterTagContainer}`).empty();
		this.$ctx.find(`.${classes.filterTags}`).hide();
		this.$ctx.find(`.${classes.teaserContainer}`).empty();

		this.getTeaserData(1);
	}

	loadMore() {
		const pageNum = this.$ctx.data("page-number");

		const materialQuery = this.getIdParameterValue(names.materialSelector);
		const industryQuery = this.getIdParameterValue(names.industrySelector);
		const dateQuery = this.getIdParameterValue(names.dateSelector);
		const regionQuery = this.getIdParameterValue(names.regionSelector);

		this.getTeaserData(pageNum, dateQuery, regionQuery, materialQuery, industryQuery);
	}

	lockLoadMoreButton() {
		this.$ctx.find(`.${classes.loadMoreBtn}`).addClass(`${classes.stateHidden}`);
	}

	unlockLoadMoreButton() {
		this.$ctx.find(`.${classes.loadMoreBtn}`).removeClass(`${classes.stateHidden}`);
	}

	lockFilters() {
		this.$ctx.find(`.${classes.oneLevelItemContainer}`).css("pointer-events", "none");
		this.$ctx.find(`.${classes.twoLevelParentHeader}`).css("pointer-events", "none");
		this.$ctx.find(`.${classes.twoLevelChildList}`).css("pointer-events", "none");
		this.$ctx.find(`.${classes.filterTags}`).css("pointer-events", "none");
	}

	unlockFilters() {
		this.$ctx.find(`.${classes.oneLevelItemContainer}`).css("pointer-events", "auto");
		this.$ctx.find(`.${classes.twoLevelParentHeader}`).css("pointer-events", "auto");
		this.$ctx.find(`.${classes.twoLevelChildList}`).css("pointer-events", "auto");
		this.$ctx.find(`.${classes.filterTags}`).css("pointer-events", "auto");
	}

	updateCounterLabel(displayNum: number, totalNumber: number) {
		const text = this.$ctx.data("counter-label")
			.replace(`${placeholders.displayNumber}`, displayNum.toString())
			.replace(`${placeholders.totalNumber}`, totalNumber.toString());
		this.$ctx.find(`.${classes.counterLabel}`).show().text(text);
	}

	updateCounterHeading(displayNum: number) {
		const text = this.$ctx.data("counter-heading")
			.replace(`${placeholders.displayNumber}`, displayNum.toString());
		this.$ctx.find(`.${classes.counterHeading}`).text(text);
	}

	updateLoadMoreButton(enable: boolean) {
		if (enable) {
			this.unlockLoadMoreButton();
		} else {
			this.lockLoadMoreButton();
		}
	}

	updatePageNumber(pageNumber: number) {
		this.$ctx.data("page-number", pageNumber);
	}

	updateFacet(enabledFilterItems: string[]) {

		// foreach all the checkboxes include the first-level and second-level,
		// but the "enabledFilterItems" only contain second-level items
		let $checkboxes = this.$ctx.find(`.${classes.filterSelect} input[type=checkbox]`);
		$checkboxes.each((i, e) => {
			const currentId = $(e).data("sc-id");
			const isEnabled = enabledFilterItems.indexOf(currentId) > -1;
			$(e).prop("disabled", !isEnabled);
		});

		// after set the "disabled" property of second-level items, update first-level
		this.setTwoLevelFilterDisabledClass();

		// update these items who are "disabled" and "checked"
		const $ele = this.$ctx.find(`.${classes.filterSelect} input[type='checkbox']:checked:disabled`);
		$ele.prop("disabled", false);
		$ele.closest(`.${classes.twoLevelChild}`).removeClass(classes.twoLevelChildDisabled);

	}

	updateNoResult() {
		const text = this.$ctx.data("no-result");
		this.$ctx.find(`.${classes.counterHeading}`).text(text);
		this.$ctx.find(`.${classes.counterLabel}`).hide();
		this.lockLoadMoreButton();
	}


	getIdParameterValue(selector: string) {

		const $ids = this.$ctx.find(`div[name='${selector}'] input:checked`);

		const arr = new Array<string>();

		$ids.each((i, e) => {
			const value = $(e).data("sc-id");
			if (typeof (value) != "undefined") {
				arr.push(value);
			}
		});

		const values = arr.join(",");
		return values;
	}

	getUniqueNameParameter(selector: string, parameterName: string) {

		let parameter: string = "";

		const $selectorInput = this.$ctx.find(`div[name=${selector}]`).find("input[type=checkbox]:checked");
		const nameArr = new Array<string>();

		$selectorInput.each((i, e) => {

			var uniqueName = $(e).data("unique-name");

			if (typeof (uniqueName) != "undefined") {
				nameArr.push(uniqueName);
			}
		});

		if (nameArr.length > 0) {
			const parameterValue = nameArr.join(",");
			parameter = `${parameterName}=${parameterValue}`;
		}

		return parameter;
	}

	getIdParameterValueFromUrl(parameterName: string) {

		const query = window.location.search.substring(1);

		const vars = query.split("&");

		for (let i = 0; i < vars.length; i++) {
			const pair = vars[i].split("=");
			if (pair[0] === parameterName) {
				const uniqueNameVariables = decodeURI(pair[1]).split(",");

				let valueArr = new Array<string>();

				for (let j = 0; j < uniqueNameVariables.length; j++) {
					const searchId = this.getIdByUniqueName(uniqueNameVariables[j]);

					if (searchId.length > 0) {
						valueArr.push(searchId);
					}
				}

				const idVariable = valueArr.join(",");

				return idVariable;

			}
		}
		return "";
	}

	getIdByUniqueName(uniqueName: string) {

		const $item = this.$ctx.find(`input[type=checkbox][data-unique-name='${uniqueName}']`);

		if ($item.length > 0) {
			return $item.data("sc-id");
		}

		return "";
	}

	generateUniqueNameQueryString(parameters: string[]) {

		let searchQuery = "";

		for (let i = 0; i < parameters.length; i++) {
			if (parameters[i].length > 0) {

				searchQuery += parameters[i];
				if (i !== parameters.length - 1) {
					searchQuery += "&";
				}
			}
		}
		if (searchQuery.length > 0) {
			searchQuery = `?${searchQuery}`;
		}

		return searchQuery;
	}

	areAllSubFiltersChecked($checkboxes: JQuery<HTMLElement>): boolean {
		return $checkboxes.toArray().every(this.isElementChecked);
	}

	isElementChecked(element: HTMLInputElement): any {
		return element.checked;
	}

	getSelectedTagHtml($inputItem: JQuery<HTMLElement>) {
		const name = $inputItem.siblings("label").text();
		const id = $inputItem.data("sc-id");
		const template = this.getTagHtml(id, name);
		return template;
	}

	getSelectedDateMonthTagHtml($inputItem: JQuery<HTMLElement>) {
		const year = $inputItem.parents(`.${classes.twoLevelParent}`).find(`.${classes.twoLevelParentHeader}`)
			.find("label").text();
		const month = $inputItem.siblings("label").text();
		const id = $inputItem.data("sc-id");
		const template = this.getTagHtml(id, `${year} ${month}`);
		return template;
	}

	getTagHtml(id: string, name: string) {
		const tagHtml =
			`<div class='m-event-list__filter-tag'>
        			<span class='m-event-list__filter-tag-text' data-selected-id=${id}>${name}</span>
         	</div>`;
		return tagHtml;
	}

	setTwoLevelFilterDisabledClass() {

		//reset child-item class
		this.$ctx.find(`.${classes.twoLevelChild}`).find('input[type=checkbox]').each((i, e) => {
			$(e).closest(`.${classes.twoLevelChild}`).toggleClass(classes.twoLevelChildDisabled, $(e).prop("disabled"));
		});

		//reset parent-item class and state
		this.$ctx.find(`.${classes.twoLevelParent}`).each((i, e) => {
			const $parentItem = $(e);
			const $checkboxes = $parentItem.find(`.${classes.twoLevelChild}`).find('input[type=checkbox]');

			$parentItem
				.find(`.${classes.twoLevelParentLink}`)
				.toggleClass(classes.twoLevelParentDisabled, this.areAllFilterDisabled($checkboxes));

			$parentItem
				.find(`.${classes.twoLevelParentHeader}`).find('input[type=checkbox]')
				.prop("disabled", this.areAllFilterDisabled($checkboxes));
		});
	}

	areAllFilterDisabled($checkboxes: JQuery) {
		return $checkboxes.toArray().every(this.isElementDisabled);
	}

	isElementDisabled(element: HTMLElement): any {
		return $(element).prop("disabled");
	}

	onOpenFilter() {
		this.$ctx.find(`.${classes.filter}`).addClass(classes.filterOpen);
	}

	onCloseFilter(event: Event) {
		event.stopPropagation();
		this.$ctx.find(`.${classes.filter}`).removeClass(classes.filterOpen);
		this.$ctx.find(`.${classes.twoLevelList}`).removeClass(classes.twoLevelListOpen);
		this.$ctx.find(`.${classes.oneLevelList}`).removeClass(classes.oneLevelListOpen);
	}

	stop() {}
}
